import React, { useRef } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowLeft, faPaperPlane } from "@fortawesome/free-solid-svg-icons";
import { Button, Col, Container, Form, Row, Card } from "react-bootstrap";
import logo from "assets/imgs/Logo-Principal-Brancopng.png";
import { Context } from "context/AuthContext";
import { useState, useContext } from "react";
import { useNavigate } from "react-router-dom";

import { POST_RECUPERAR_SENHA } from "../../../../services/Usuario";

import "../../../RedefinirSenha/styles.scss";
import { useAlert } from "context/AlertContext";

const initialState = {
  email: "",
};

const ContentRecoverPassword = (props) => {
  const navigate = useNavigate();
  const { showAlert } = useAlert();
  const alertRef = useRef(null);

  const { showLoader } = useContext(Context);
  const [values, setValues] = useState(initialState);
  const [errors, setErrors] = useState([]);

  function onChange(event) {
    const { value, name } = event.target;

    setValues({
      ...values,
      [name]: value,
    });
  }

  async function onSubmit(event) {
    event.preventDefault();

    const errors = validate();

    if (errors.length > 0) {
      setErrors(errors);

      setTimeout(() => {
        if (alertRef.current) {
          alertRef.current.scrollIntoView({ behavior: "smooth" });
        }
      }, 0);

      return;
    }

    setErrors([]);
    showLoader(true);

    const result = await POST_RECUPERAR_SENHA({
      email: values["email"],
    });
    showLoader(false);

    if (result && result.errors && result.errors.length > 0) {
      setErrors(result.errors);
      showAlert(result.errors[0], "danger");
    } else {
      navigate("/email-recuperacao-enviado");
    }
  }

  const validate = () => {
    let errors = {};

    if (!values.email) {
      errors.email = "O campo email é obrigatório";
    }

    return errors;
  };

  return (
    <div className="content-wrapper">
      <Container>
        <Row className="vh-100 d-flex justify-content-center align-items-center content-redefinir-senha">
          <Col md={8} lg={10} xs={12}>
            <Card className="shadow">
              <Row className="g-0 h-100">
                <Col md={4} className="column-img-redefinir-senha ">
                  <img
                    src={logo}
                    alt="Imagem de registro"
                    className="img-fluid card-img"
                  />
                </Col>
                <Col md={8}>
                  <Card.Body className="h-100 d-flex flex-column m-3">
                    <div className="mb-3 mt-4">
                      <h3 className="fw-bold  mb-2">Redefinir senha</h3>
                      <p className="mb-5">
                        Digite seu email cadastrado no campo abaixo que
                        enviaremos as instruções para recuperação da sua senha:
                      </p>
                      <Form className="flex-grow-1 d-flex flex-column justify-content-between">
                        <div>
                          <Row className="mb-3">
                            <Form.Group
                              as={Col}
                              className="mb-3"
                              controlId="formEmail"
                            >
                              <Form.Label className="text-center">
                                Email
                              </Form.Label>
                              <Form.Control
                                name="email"
                                type="email"
                                placeholder="Digite seu email"
                                list="email-options"
                                onChange={onChange}
                                // isInvalid={!!errors.email}
                              />
                              <Form.Control.Feedback type="invalid">
                                {/* {errors.email} */}
                              </Form.Control.Feedback>
                            </Form.Group>
                          </Row>
                        </div>

                        <div className="d-flex justify-content-between gap-3">
                          <Button
                            variant="primary"
                            type="button"
                            onClick={() => navigate("/login")}
                          >
                            <FontAwesomeIcon icon={faArrowLeft} /> Voltar
                          </Button>
                          <Button
                            variant="primary"
                            type="submit"
                            onClick={onSubmit}
                          >
                            Enviar
                          </Button>
                        </div>
                      </Form>
                    </div>
                  </Card.Body>
                </Col>
              </Row>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default ContentRecoverPassword;
